import { useStore } from 'react-redux'

import { RootState } from '../types'

function useAppStore() {
  return useStore<RootState>()
}

export default useAppStore
